'use client'

import { AlertTriangle, Home, RefreshCw } from 'lucide-react'
import { useEffect } from 'react'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error('[global-error]', error)
  }, [error])

  const incidentCode = `INC-${(error.digest ?? 'XXXX').slice(0, 8).toUpperCase()}`

  return (
    <html lang="pt-BR">
      <body className="min-h-screen bg-zinc-50 dark:bg-zinc-950 flex items-center justify-center p-4">
        <div className="max-w-md w-full bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 rounded-3xl p-8 text-center shadow-xl">
          <div className="mx-auto h-14 w-14 rounded-2xl bg-amber-100 dark:bg-amber-900/40 flex items-center justify-center mb-5">
            <AlertTriangle className="h-7 w-7 text-amber-600 dark:text-amber-400" />
          </div>
          <h1 className="text-xl font-bold text-zinc-900 dark:text-zinc-100">
            Ops, algo deu errado
          </h1>
          <p className="text-sm text-zinc-600 dark:text-zinc-400 mt-3 leading-relaxed">
            Encontramos um problema inesperado. Nossa equipe já foi avisada e está investigando.
          </p>
          <div className="mt-4 inline-block bg-zinc-100 dark:bg-zinc-800 px-3 py-1.5 rounded-full text-xs font-mono font-bold text-zinc-700 dark:text-zinc-300">
            {incidentCode}
          </div>
          <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
            <button
              type="button"
              onClick={reset}
              className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-full bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700"
            >
              <RefreshCw className="h-4 w-4" />
              Tentar novamente
            </button>
            <a
              href="/"
              className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-full bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-700 text-zinc-700 dark:text-zinc-300 text-sm font-semibold hover:bg-zinc-50 dark:hover:bg-zinc-800"
            >
              <Home className="h-4 w-4" />
              Ir pra home
            </a>
          </div>
        </div>
      </body>
    </html>
  )
}
